import React from 'react';
import styles from './rectangleComp.module.scss';
import Card from '../Card';

const RectangleComp = () => {
  const sampleData = [
    'Install all critical updates',
    'Keep all third party softwares up to date',
    'Install google chrome in all devices',
    'Don’t update the windows patches in any devices',
    'Install Microsoft teams on all devices',
  ];

  return (
    <Card className="flex-1">
      <span className={styles.heading}>Quick Policy</span>
      <div className={`${styles.underline}`}></div>
      <div>
        {sampleData.map((item, index) => (
          <div key={index} className={styles.rectangleArea}>
            <span className={styles.text}>{item}</span>
            <img src={require('../../icons/vector_icon.png')} alt="" className={styles.img} />
          </div>
        ))}
      </div>
    </Card>
  );
};

export default RectangleComp;
